import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import { Link } from "react-router-dom";

const PaychPub = () => {
  return (
    <React.Fragment>
      <SEO title="会议注册费| ICSI 2026" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="支付会议注册费"
        content="公众会议注册"
        contentTwo="支付会议注册费"
        linkage="/registration_pub"
      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div classNameName="entry-header">
          <h3>会议注册费</h3>
          <br />
          <span className="pay-guide">
            (If you need English Payment Guidance, please click{" "}
            <a className="simple-link" href="pay_pub">
              here
            </a>
            )
          </span>
        </div>
        <div classNameName="entry-content">
          <div className="fee">
            <div align="center">
              <br />
              <h5>注册费明细</h5>
            </div>
            <table className="fee">
              <tr>
                <td width="183">
                  <p align="center">项目 </p>
                </td>
                <td width="152">
                  <p align="center">费用（人民币元） </p>
                </td>
                <td width="500">
                  <p align="center">内容 </p>
                </td>
              </tr>
              {/* <tr>
                              <td width="183" ><p align="center">正常注册 </p></td>
                              <td width="152" ><p align="center">5200</p></td>
                              <td width="691"><p>这适合于有论文录用的参会者。<br/>
                                包括：Springer-LNCS论文集上发表1篇论文，电子版论文集，会议程序册，会议包，胸牌，出席所有的大会报告会、平行口头报告会和板报研讨会，等。 <br/>
                              </p></td>
                            </tr> */}
              <tr>
                <td>
                  <div align="center">简化注册 </div>
                </td>
                <td>
                  <div align="center">5000</div>
                </td>
                <td>
                  <div align="center">
                      <b>公众注册现场参加会议。</b>
                      <br />
                    包括：电子版论文集，会议程序册，会议包，胸牌，出席所有的大会报告会、平行口头报告会和板报研讨会，会议期间的午餐与晚宴券。{" "}
                  </div>
                </td>
              </tr>

              {/* <tr>
                <td>
                  <div align="center">简化线上注册 </div>
                </td>
                <td>
                  <div align="center">2350</div>
                </td>
                <td>
                  <div align="center">
                    <p>
                      这适用于以下情况：
                      <br />
                      <b>没有论文发表的线上参会者。</b>
                      <br />
                    </p>
                  </div>
                </td>
              </tr> */}

              {/* <tr>
                              <td colSpan="3" >&nbsp;</td>
                            </tr>
                            
                            <tr>
                              <td width="183" ><p align="center">超页 </p></td>
                              <td width="152" ><p align="center">800</p></td>
                              <td width="691" ><p align="left">如果论文超过12页，每1个超页。 </p></td>
                            </tr>

                            <tr>
                              <td width="183" ><p align="center">宴会券 </p></td>
                              <td width="152" ><p align="center">650</p></td>
                              <td width="691" ><p align="left">每1张宴会券。 </p></td>
                            </tr>

                            <tr>
                              <td width="183" ><p align="center">午餐券 </p></td>
                              <td width="152" ><p align="center">300</p></td>
                              <td width="691" ><p align="left">每1张午餐券。 <a href="http://item.taobao.com/item.htm?id=22998448148"></a></p></td>
                            </tr> */}
            </table>
            <br />
            <span>
              <b>注意：</b>
            </span>
            <div align="justify">
              <ul>
                <li>
              关于发票：本次国际会议默认都提供英文收据（Receipt）。如果你需要换开中文正规发票，请您在完成注册缴费后，在问卷中填写发票信息。经审核无误后会尽快为您开具相应的正规电子发票。{" "}
              </li>
              <li>
              <li>
                关于汇率：本次国际会议以美元结算，人民币按照2026年5月5日的实时汇率（6.83）进行计算。
               </li>
              </li>
              <li>
                如果您选择线上参会，注册的费用可以享受50%的折扣。
              </li>
              </ul>
              
            </div>
          </div>
          <p>&nbsp;</p>
          <hr />
          <p>&nbsp;</p>
          <div className="post-entry">
            {" "}
            <h3>收款方式</h3>
            <br />
            <h5>1.收款二维码：</h5>
            <br />
            <p align="center">
              <img src="./images/reg/yunpay.jpg" alt="2dQr" width="450" />
            </p>
            <p align="center">&nbsp;</p>
            <p className="STYLE39">
              请将会议注册费直接转账到上面云收款二维码账户中，然后将
              <span className="STYLE23">交易成功网页</span>
              保存为图片文件，并在随后填写
              
                Online Registration Form
              时上传。需在备注栏填写会议名称和姓名，即&quot;ICSI2026/xxx&quot;（其中&quot;xxx&quot;为注册人的姓名）。
            </p>
            <p>&nbsp;</p>
            <hr />
            <p>&nbsp;</p>
            <p>
              <h5> 2. 普通银行转账：</h5>
            </p>
            <span className="STYLE27">账号信息</span>
            <ul>
              <li>账户名称：北京兴汇科技有限公司</li>
              <li>开户行名称：平安银行股份有限公司北京中关村支行</li>
              <li>开户银行帐号：11014748324007</li>
            </ul>
            <p>
              <span>
                <strong>特别注明：</strong>
              </span>
              <li>
                通过银行转账付款的需要备转账的姓名，同时需要保留交费的凭据，在后续填写注册信息的时候需要上传凭证。
              </li>
              <li>
                注册中有什么疑问，请及时与会务组联系。
                <br />
              </li>
            </p>
          </div>
          <p align="center">&nbsp;</p>
          <div className="btn-nav-pay">
            {/* <a
              className="btn btn-primary btn-hover-secondary mt-s"
              href="https://wj.qq.com/s2/9997438/2b92/"
            >
              Fill Online Registration Form
            </a> */}
            <Link
              className="btn btn-primary btn-hover-secondary  mt-s"
              to={process.env.PUBLIC_URL + "/form_pub"}
            >
              Fill Online Registration Form
              {/* Back to Registration page */}
            </Link>
            <br />
            <Link
              className="btn btn-primary btn-hover-secondary  mt-s"
              to={process.env.PUBLIC_URL + "/registration_pub"}
            >
              Back to Registration page
            </Link>

            {/* <p>
              <a href="/Registration">Back to Registration page </a>
            </p>
            <p>
              <a href="https://iasei.org/survey/index.php/677672?lang=en">
                Fill Online Registration Form{" "}
              </a>
            </p> */}
          </div>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classNameOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default PaychPub;
